import Tone from 'tone';
import {voiceFactory} from './VoiceFactory.js';

export default superclass => class extends superclass  {
    _voices = [];

    releaseVoice(v, disconnectFM=true) {
        voiceFactory.releaseVoice(v, disconnectFM, this.sequencerEngine);
    }

    onPolyphonyChanged(x) {
        if (x > this._voices.length) {
            for (let i=this._voices.length; i < x; i++) {
                let voice = this.newVoice();
                this.fm(this.carrier, true, voice, i);
                this._voices.push(voice);
            }

            if (this.customOscillatorType) {
                this.customOscillatorTypeParameter.updateRedux();
            } 
            this.setAudioParamsForParameters();
        }  else if (x < this._voices.length) {
            // then we need to release the voices
            let voicesToRelease = this._voices.slice(x);
            voicesToRelease.forEach(
                v => this.releaseVoice(v));
            this._voices = this._voices.slice(0, x);
        }

        if (this.oscillatorTypeParameter && this.oscillatorTypeParameter.get() === 'pulse') {
            this.pulseWidthParameter.setAudioParams(
                this.voices.map(v => v.oscillator.width));
        }
    }

    initVoices() {
        this._voices = [
            this.newVoice()
        ];
    }

    get voices() {
        if (!this._voices) {
            return [];
        }
        if (!this.polyphonyParameter) {
            return this._voices;
        }
        return this._voices.slice(0, this.polyphonyParameter.get());
    }

    get synth() {
        return this;
    }

    newVoice() {
        let voice = undefined;
        if (this.oscillatorTypeParameter && this.oscillatorType) {
            let v = voiceFactory.newVoice(this.oscillatorType, this.name);
            if (this.oscillatorType.includes("fat")) {
                this._voices.forEach(
                    v => v.oscillator.type = 'sine');
                this._voices.forEach(
                    v => {
                        v.oscillator.type = this.oscillatorType;
                        v.oscillator.count = this.countParameter.get();
                        v.oscillator.spread = this.spreadParameter.get();
                    });
            }
            return v;
        } else {
            return voiceFactory.newVoice(undefined, this.name);
        }
    }
}
